import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import {
  getChatUserList,
  getSerachChatUserlist,
} from "../../../../redux/chatandnotification/action";
import { getTimeandhours } from "../../../Common/AllDateTimeReleventFormate";
import ProfilePic from "../../../../assests/imgs/Profileplaceholder.svg";
import ProfileImageWithFallback from "../../../../common/ProfileImageWithFallback";
import CloseSearchbutton from "./CloseSearchbutton";
import { useChatPagination } from "../../../../Context/ChatPaginationContext";

export default function ChatUserList({ selectUser, setselectUser }) {
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const { setIndex, index } = useChatPagination();

  const serachallusers = useSelector(
    ({ chatandnotification: { serachallusers } }) => serachallusers
  );
  const getchatuserlists = useSelector(
    ({ chatandnotification: { getchatuserlists } }) => getchatuserlists
  );
  const [searchtext, setSearchtext] = useState("");
  const [debouncedSearchtext, setDebouncedSearchtext] = useState("");
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);

  // Fetch chat user list on mount
  useEffect(() => {
    dispatch(getChatUserList());
  }, [dispatch]);

  // Debounce search input
  useEffect(() => {
    const handler = setTimeout(() => {
      const trimmed = searchtext.trim();
      setDebouncedSearchtext(trimmed);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchtext]);

  // Fetch searched users only if input is not empty
  useEffect(() => {
    if (debouncedSearchtext !== "") {
      dispatch(getSerachChatUserlist(debouncedSearchtext));
      setModal(true); // show modal only for valid input
    } else {
      setModal(false); // hide modal for empty or spaces
    }
  }, [debouncedSearchtext, dispatch]);

  return (
    <div className="message-left">
      <div className="chat-left-header">
        <h5>Messages</h5>
        <div className="w-100 search-bar">
          <input
            type="text"
            className="form-control"
            value={searchtext}
            onChange={(e) => setSearchtext(e.target.value)}
            placeholder="Search name"
          />
          <CloseSearchbutton setSearchtext={setSearchtext} searchtext={searchtext} />
          <button className="btn search-btn">
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/common/search-btn.svg`}
              alt=""
            />
          </button>
        </div>

        {/* Show search dropdown only if modal is true */}
        {modal && (
          <div className="search-chat">
            {Array.isArray(serachallusers) && serachallusers.length > 0 ? (
              serachallusers.map((item, index) => (
                <div
                  className="message-box"
                  key={index}
                  onClick={() => {
                    setIndex(0)
                    setselectUser(item);
                    setModal(false);
                    setSearchtext(""); // optional: clear input on select
                  }}
                  style={{
                    background:
                      (selectUser?.user_id || selectUser?.id) ===
                        (item?.user_id || item?.id)
                        ? "red"
                        : "",
                  }}
                >
                  <div className="messagebox-left">
                    <ProfileImageWithFallback url={item.profile_image} className="" />
                    <div>
                      <h6>{item?.name}</h6>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="no-results">
                <p>No results found</p>
              </div>
            )}
          </div>
        )}
      </div>

      <div className="chatleft-row">
        {Array.isArray(getchatuserlists) &&
          getchatuserlists.map((item, index) => (
            <div
              className="message-box"
              key={index}
              onClick={() => {
                    setIndex(0)
                setselectUser(item);
                setModal(false);
              }}
              style={{
                background:
                  (selectUser?.user_id || selectUser?.id) ===
                    (item?.user_id || item?.id)
                    ? "#FFF2E7"
                    : "",
              }}
            >
              <div className="messagebox-left">
                <ProfileImageWithFallback url={item.profile_image} className="" />
                <div>
                  <h6>
                    {item?.first_name} {item?.last_name}
                  </h6>
                  <p>
                    {item?.message && item.message.length > 35
                      ? `${item.message.slice(0, 35)}...`
                      : item?.message}
                  </p>
                </div>
              </div>
              <div className="messagebox-right">
                {item?.unseen_count > 0 ? (
                  <span>{item?.unseen_count}</span>
                ) : item?.seen === 0 ? (
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/common/disable-tick.svg`}
                    alt=""
                  />
                ) : (
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/common/active-tick.svg`}
                    alt=""
                  />
                )}
                <p className="time">{getTimeandhours(item?.created_on)}</p>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}
